import { render } from "./Stack.vue?vue&type=template&id=6961ffd6&scoped=true"
import script from "./Stack.vue?vue&type=script&lang=js"
export * from "./Stack.vue?vue&type=script&lang=js"

import "./Stack.vue?vue&type=style&index=0&id=6961ffd6&scoped=true&lang=css"

import exportComponent from "/home/adrianhardy/projects/Clients/O/Orchard_Crown_Ltd/ionic-storeroom/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6961ffd6"]])

export default __exports__